(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider
                .state("Home.Tools.MarketingTrackerNew.Events",
                    {
                        url: "/Events",
                        component: "events",
                        redirectTo: "Home.Tools.MarketingTrackerNew.Events.EventsSummary"
                    });
        }
    ]);

    app
        .component("events",
            {
                templateUrl: "App/Tools/MarketingTrackerNew/Events/events-template.html",
                controller: eventsController,
                bindings: {
                    user: "<",
                    onBehalfOfUser: "<"
                }
            });

    eventsController.$inject = [];
    function eventsController() {
        var $ctrl = this;
    }

})(window.app, window.angular); //jshint ignore:line